/**
 * A global namespace for `resize` event.
 */
const resizeEvent = 'resize';
export default resizeEvent;
